module.exports = __webpack_public_path__ + "img/ss2.ab8d9cd9.jpg";